import { render, staticRenderFns } from "./the-trackers.vue?vue&type=template&id=3f521e9a&scoped=true"
import script from "./the-trackers.vue?vue&type=script&lang=js"
export * from "./the-trackers.vue?vue&type=script&lang=js"
import style0 from "./the-trackers.vue?vue&type=style&index=0&id=3f521e9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f521e9a",
  null
  
)

export default component.exports